import { IonButton, IonImg, IonLabel, IonModal, isPlatform } from "@ionic/react";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import * as constants from "../../../constants";
import Calendar from "react-calendar";
import moment from "moment";
import {
	deleteBookingTransaction,
	fetchBookings,
	getTimeSlots,
	rescheduleBooking,
	cancelBooking,
} from "../../../Store/Actions";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { ToastMessage } from "../../../utils/toastMessage";

export const MyBookingsStatusCard: React.FC = (props: any) => {
	const { uiChangeReq, modalOpenValue, setModalValue } = props;
	const [showCalendar, setShowCalendar] = useState(false);
	const [toast, setToast] = useState({
		showToast: false,
		toastMessage: "",
		severity: "",
	});

	const [dateTemp, setDateTemp] = useState(new Date());
	const [date, setDate] = useState(
		!!props.pickupDropoffData && !!props.pickupDropoffData.pickupDate
			? new Date(props.pickupDropoffData.pickupDate)
			: new Date()
	);
	const [showSlotModal, setShowSlotModal] = useState(false);
	const [slot, setTimeSlot] = useState("");
	const [hideCancelButton, setHideCancelButton] = useState(false);
	const [reservationStatus, setReservationStatus] = useState([]);
	const [time_arr, setTimeArray] = useState([]);
	const {
		bookingCode,
		bookingId,
		createdAt,
		estimate,
		events,
		isPickupRequired,
		items,
		pickupDropoffData,
		status,
		userVehicleId,
		orders,
		notes,
		workshopImages,
		userImages,
		payments,
		invoiceUrl,
	} = props;

	useEffect(() => {
		isStatusPickupScheduled();
	}, [events]);
	useEffect(() => {
		setReservationStatus(props.reservationStatus);
	}, [props]);

	const isStatusPickupScheduled = () => {
		const statusIndex = events.findIndex(
			(item: any, ind: any) => item.name === "Pickup Scheduled"
		);
		if (statusIndex && !!events[statusIndex] && !!events[statusIndex].updatedAt) {
			setHideCancelButton(true);
		} else {
			setHideCancelButton(false);
		}
	};

	const workStatus = [
		"Estimate",
		"Work-In Progress",
		"Spares-Pending",
		"Ready for Delivery",
		"Invoice",
		"Payment Pending",
		"Delivered",
	];
	let reservationWorkStatus = "";
	if (!!reservationStatus && reservationStatus.length > 0) {
		reservationStatus.map((item: any) => {
			if (workStatus.indexOf(item.ticketStatus) > -1) {
				reservationWorkStatus = item.ticketStatus;
			}
		});
	}
	const bookingCategories = [] as any;
	events.map((ele: any, ind: any) => {
		if (!bookingCategories.includes(ele.category)) {
			bookingCategories.push(ele.category);
		}
	});

	const Categories = bookingCategories.map((item: any, ind: any) => {
		return item;
	});

	const GroupStatus = Categories.map((d1: any, ind1: any) => {
		return events.map((d2: any, ind2: any) => {
			if (d1 === d2.category) {
				return d2;
			}
		});
	}).map((x: any) => {
		return x.filter((y: any) => !!y);
	});

	const getStatusIndex = workStatus.findIndex(
		(item: any) => item.toLowerCase() === reservationWorkStatus.toLowerCase()
	);

	const FinalStatus = GroupStatus.map((t1: any, ind: any) => {
		if (ind === 0 || ind === 1 || getStatusIndex - 1 === workStatus.length) {
			return { category: Categories[ind], status: "completed" };
		} else if (ind === 2) {
			return { category: Categories[ind], status: "inprogress" };
		} else {
			return { category: Categories[ind], status: "initiated" };
		}
	});
	// const FinalStatus = GroupStatus.map((t1: any, ind: any) => {
	//   if (t1.every((val: any) => val.updatedAt)) {
	//     return { category: Categories[ind], status: "completed" };
	//   } else if (t1.some((val: any) => val.updatedAt)) {
	//     return { category: Categories[ind], status: "inprogress" };
	//   } else {
	//     return { category: Categories[ind], status: "initiated" };
	//   }
	// });
	const progressPercentage = GroupStatus.map((v1: any, ind: number) => {
		if (ind === 0 || ind === 1 || getStatusIndex + 1 === workStatus.length) {
			return 100;
		} else if (ind === 2) {
			return ((getStatusIndex + 1) / workStatus.length) * 100;
		} else {
			return 0;
		}
	});
	// const progressPercentage = GroupStatus.map((v1: any) => {
	//   return (v1.filter((ele: any) => ele.updatedAt).length / v1.length) * 100;
	// });

	const days = ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"];
	const months = [
		"Jan",
		"Feb",
		"Mar",
		"Apr",
		"May",
		"June",
		"July",
		"Aug",
		"Sep",
		"Oct",
		"Nov",
		"Dec",
	];

	React.useEffect(() => {
		// console.log("Time date received", props.time_slots);

		var currDate: Date = new Date();
		currDate.setHours(0, 0, 0, 0);

		let timeSlotCheckIsRequired = false;
		// if(dateTemp.getTime() === currDate.getTime()){
		//   console.log("Selected date is same date");
		//   timeSlotCheckIsRequired = true;
		// }
		// else if(dateTemp.getTime() < currDate.getTime()){
		//   console.log("Selected date is lower date");
		//   setToast({
		//     showToast: true,
		//     toastMessage: "Invalid date",
		//     severity: "warning",
		//   });
		//   setTimeArray([]);
		//   return;
		// }
		// else {
		//   console.log("Selected date is higher date");
		// }

		let curDt: Date = new Date(currDate);
		curDt.setHours(0, 0, 0, 0);

		let tempDt: Date = new Date(dateTemp);
		tempDt.setHours(0, 0, 0, 0);

		console.log("Date === ", dateTemp > currDate);

		if (tempDt >= curDt) {
			console.log("Selected date is same date ..... 0");
			timeSlotCheckIsRequired = true;
		} else {
			// setToast({
			// 	showToast: true,
			// 	toastMessage: "Invalid date",
			// 	severity: "warning",
			// });
			setTimeArray([]);
			return;
		}

		let timeDt = dateTemp;

		if (timeSlotCheckIsRequired) {
			const timeArr = props.time_slots.filter((ele: any) => {
				timeDt.setHours(parseInt(ele.startTime.split(":")[0]));
				return timeDt > currDate;
			});
			setTimeArray(timeArr);
		} else {
			setTimeArray(props.time_slots);
		}
	}, [props.time_slots]);

	const changeDate = (d: any) => {
		setDate(d);
		setDateTemp(d);
		var dateFormat = moment(new Date(d)).format("DD/MM/YYYY");
		// if (d >= new Date(props.firstAvailable) && d <= new Date(props.lastAvailable)) {
		//   props.getTimeSlots(dateFormat, getWorkShopId[0]);
		// }

		let fDate = new Date();
		let lDate = new Date();

		if (props.firstAvailable.length > 0) {
			fDate = new Date(props.firstAvailable);
			lDate = new Date(props.lastAvailable);
		}

		fDate.setHours(0, 0, 0, 0);
		lDate.setHours(0, 0, 0, 0);

		// if (d >= new Date(props.firstAvailable) && d <= new Date(props.lastAvailable)) {
		if (d.getTime() >= fDate.getTime()) {
			//&& d.getTime() <= lDate.getTime()) {
			props.getTimeSlots(dateFormat, getWorkShopId[0]);
		}
	};

	const changeTimeSlot = (slot: any) => {
		setTimeSlot(slot);
	};

	const getWorkShopId = props.bookingList
		.filter((ele: any) => ele.bookingId === props.bookingId)
		.map((item: any) => {
			return item.items[0].workshopId;
		});

	const onBookingCancel = async (bkId: any) => {
		const updateStatus = "Cancelled";
		const createdRemoved = payments.map((item: any) => {
			delete item.createdAt;
			return item;
		});
		await props.cancelBooking(
			{
				bookingCode,
				bookingId,
				estimate,
				events,
				isPickupRequired,
				items,
				pickupDropoffData,
				userVehicleId,
				orders: orders.map((ele: any) => {
					const { createdAt, ...rest } = ele;
					return rest;
				}),
				notes,
				workshopImages,
				userImages,
				payments: createdRemoved,
				invoiceUrl,
				status: updateStatus,
			},
			bkId,
			"Booking cancelled successfully"
		);
		setModalValue(false);
		props.history.push({
			pathname: "/portal/booking_details",
			state: {
				idOfBooking: bkId,
			},
		});
	};

	const onBookingReschedule = async () => {
		try {
			if (!slot) {
				throw Error("Please select a slot");
			}
			setShowSlotModal(!showSlotModal);
			if (pickupDropoffData) {
				pickupDropoffData.pickupDate = moment(new Date(date)).format("YYYY-MM-DD");
				const obj = {
					startTime: !!slot.split("-")[0] ? slot.split("-")[0] : "",
					endTime: !!slot.split("-")[1] ? slot.split("-")[1] : "",
				};
				pickupDropoffData.pickupSlot = obj;
				const createdRemoved = payments.map((item: any) => {
					delete item.createdAt;
					return item;
				});

				let startUTCTime = moment.utc(
					new Date(moment(new Date(date)).format("YYYY-MM-DD") + " " + slot.split("-")[0])
				);
				// console.log("Reschedule - 2 > UTC Start Time ==== ", startUTCTime.toISOString());

				let endUTCTime = moment.utc(
					new Date(moment(new Date(date)).format("YYYY-MM-DD") + " " + slot.split("-")[1])
				);
				// console.log("Reschedule - 2 > UTC End Time ==== ", endUTCTime.toISOString());

				await props.rescheduleBooking(
					{
						bookingCode,
						bookingId,
						estimate,
						events,
						isPickupRequired,
						items,
						startTime: startUTCTime,
						endTime: endUTCTime,
						pickupDropoffData,
						userVehicleId,
						orders: orders.map((ele: any) => {
							const { createdAt, ...rest } = ele;
							return rest;
						}),
						notes,
						workshopImages,
						userImages,
						payments: createdRemoved,
						invoiceUrl,
						status,
					},
					bookingId
				);
			}
			// await props.fetchBookings();
		} catch (e: any) {
			setToast({
				showToast: true,
				toastMessage: e.message,
				severity: "warning",
			} as any);
		}
	};

	// useEffect(() => {
	//   window.addEventListener("mousedown", handleOutsideClick);
	//   window.addEventListener("keydown", handleEscKeyPress);
	//   return () => {
	//     window.removeEventListener("mousedown", handleOutsideClick);
	//     window.removeEventListener("keydown", handleEscKeyPress);
	//   };
	// }, []);

	const handleOutsideClick = (event: any) => {
		setModalValue(false);
	};
	const handleEscKeyPress = (event: any) => {
		if (event.key === "Escape") {
			setModalValue(false);
		}
	};

	return (
		<>
			<div
				className={
					uiChangeReq
						? "rec_ser_prnt width_100per cursor_none margin-bottom-0 relative marginTop10px"
						: "rec_ser_prnt width_100per last_ele cursor_none relative"
				}
				style={{ marginTop: uiChangeReq ? 0 : isPlatform("ios") ? 110 : 70 }}
			>
				<div className="mb_status_cont">
					<div
						className={
							uiChangeReq && !isPlatform("mobile") && !isPlatform("mobileweb")
								? "bkng_cont booking_id_additional"
								: "bkng_cont"
						}
						onClick={() => {
							props.history.push({
								pathname: "/portal/booking_details",
								state: {
									idOfBooking: props.bookingId,
								},
							});
						}}
					>
						<IonLabel
							className={uiChangeReq ? "bkng_id_text bkng_id_text_add" : "bkng_id_text"}
						>
							Booking Id
						</IonLabel>
						<IonLabel className={uiChangeReq ? "bkng_id bkng_id_add" : "bkng_id"}>
							{bookingCode}
						</IonLabel>
					</div>
					<div className="bkng_status_parent">
						<div
							className={
								uiChangeReq ? "bkng_status_cont dashboard_div" : "bkng_status_cont"
							}
						>
							<div className="bkng_sts_dot" />
							<IonLabel
								className={uiChangeReq ? "booking_sts booking_sts_add" : "booking_sts"}
							>
								Active
							</IonLabel>
						</div>
						{/* {!hideCancelButton && (
              <div className="three_dots">
                {modalOpenValue && (
                  <div
                    className={
                      uiChangeReq && !isPlatform("mobile") && !isPlatform("mobileweb")
                        ? "resche_can_popup resche_can_popup_add"
                        : "resche_can_popup"
                    }
                  >
                    <div
                      className="cursor_pointer sts_dot_inside"
                      onClick={() => setModalValue(!modalOpenValue)}
                    >
                      {new Array(3).fill(0).map((val, ind) => (
                        <div key={ind} className="sts_dot" />
                      ))}
                    </div>
                    {isPickupRequired && (
                      <IonLabel
                        className="reschedule_text "
                        // TODO: Disabled for time being, uncomment onClick() to enable
                        onClick={(e: any) => {
                          setShowCalendar(true);
                          setModalValue(false);
                        }}
                      >
                        {constants.RESCHEDULE}
                      </IonLabel>
                    )}

                    <IonLabel
                      // TODO: Disabled for time being, uncomment onClick() to enable
                      onClick={() => onBookingCancel(bookingId)}
                      aria-disabled="true"
                      className="reschedule_text "
                    >
                      {constants.BD_CANCEL}
                    </IonLabel>
                  </div>
                )}
                <div className="cursor_pointer" onClick={() => setModalValue(true)}>
                  {new Array(3).fill(0).map((val, ind) => (
                    <div key={ind} className="sts_dot" />
                  ))}
                </div>
              </div>
            )} */}
					</div>
				</div>
				<div className="bkng_statusbar_par">
					{FinalStatus.map((ele: any, ind: any) => (
						<div
							className={
								ind === 0
									? "bkng_status_bar_cont marginLeft23or27"
									: ind === 3
									? "bkng_status_bar_cont last_circle"
									: "bkng_status_bar_cont"
							}
							key={ind}
						>
							<div className="three_dots" style={{ position: "relative" }}>
								<IonLabel
									className={
										uiChangeReq
											? ele.status === "inprogress" ||
											  ele.status === "completed" ||
											  progressPercentage[ind - 1] === 100
												? "sts_text sts_text_add mb_black"
												: "sts_text sts_text_add"
											: ele.status === "inprogress" ||
											  ele.status === "completed" ||
											  progressPercentage[ind - 1] === 100
											? "sts_text mb_black"
											: "sts_text"
									}
									style={{ position: "absolute", top: 0 }}
								>
									{ele.category.toLowerCase() === "booking status"
										? "Booking"
										: ele.category.toLowerCase() === "pick status"
										? "Pickup"
										: ele.category.toLowerCase() === "work status"
										? "Service"
										: ele.category.toLowerCase() === "drop status"
										? "Drop"
										: ""}
								</IonLabel>

								{ele.status === "inprogress" ||
								ele.status === "completed" ||
								progressPercentage[ind - 1] === 100 ? (
									<div
										className={
											uiChangeReq
												? "sts_round_2 height_width_41 commonStyle"
												: "sts_round_2 commonStyle"
										}
									>
										<div className="circularCont">
											<CircularProgressbar
												value={progressPercentage[ind]}
												strokeWidth={12}
												styles={buildStyles({
													strokeLinecap: "butt",
													pathColor: "white",
													trailColor: "rgba(255, 255, 255, 0.5)",
												})}
											/>
										</div>
									</div>
								) : (
									<div
										className={
											uiChangeReq ? "sts_round_1 height_width_27" : "sts_round_1"
										}
										style={{ marginTop: 25 }}
									/>
								)}
							</div>
							{ind < FinalStatus.length - 1 && (
								<div className="hor_line" style={{ marginTop: 40 }} />
							)}
						</div>
					))}
					{/* <div className="three_dots">
            <IonLabel className="sts_text">{constants.COMPLETED}</IonLabel>
            <div
              className={
                uiChangeReq ? "sts_round_1 height_width_27" : "sts_round_1"
              }
            />
          </div> */}
				</div>
				<div className="bked_cost_cont">
					<div
						className={
							uiChangeReq && !isPlatform("mobile") && !isPlatform("mobileweb")
								? "cost_cont booking_id_additional"
								: "cost_cont"
						}
					>
						<IonLabel
							className={
								uiChangeReq
									? "bked_estimated_cost_text bkng_id_text_add"
									: "bked_estimated_cost_text"
							}
						>
							{constants.ESTIMATED_COST}
						</IonLabel>
						<IonLabel
							className={uiChangeReq ? "bked_price_text bkng_id_add" : "bked_price_text"}
						>{`${constants.RupeeSymbol} ${estimate.totalEstimated}`}</IonLabel>
					</div>
					{!!isPickupRequired ? (
						<>
							{!!pickupDropoffData && (
								<div className="pickup_time_cont">
									{[
										"Pickup",
										moment(pickupDropoffData.pickupDate).format("DD MMM, YY"),
										pickupDropoffData.pickupSlot.startTime,
									].map((val, index) => (
										<div className="pickup_pill" key={index}>
											<div
												className={
													uiChangeReq
														? "bked_estimated_cost_text sts_text_add"
														: "bked_estimated_cost_text"
												}
											>
												{val}
											</div>
										</div>
									))}
								</div>
							)}
						</>
					) : (
						<div className="pickup_pill">
							<div
								className={
									uiChangeReq
										? "bked_estimated_cost_text sts_text_add"
										: "bked_estimated_cost_text"
								}
							>
								Drop at
							</div>
						</div>
					)}
				</div>
			</div>
			<IonModal
				isOpen={showCalendar}
				backdropDismiss={true}
				onDidDismiss={() => {
					setShowCalendar(false);
				}}
				cssClass="picker-modal"
			>
				<div className="picker-header">
					<IonLabel className="picker-header-year">
						{new Date(date).getFullYear()}
					</IonLabel>
					<div className="picker-header-month-date-div">
						<IonLabel className="picker-header-month-date">
							{days[new Date(date).getDay()]}
							{", "}
						</IonLabel>
						<IonLabel className="picker-header-month-date">
							{new Date(date).getDate()}{" "}
						</IonLabel>
						<IonLabel className="picker-header-month-date">
							{months[new Date(date).getMonth()]}
						</IonLabel>
					</div>
				</div>
				<Calendar
					onChange={(date: any) => changeDate(date)}
					value={new Date(date)}
					minDate={new Date(props.firstAvailable)}
					maxDate={new Date(props.lastAvailable)}
					defaultActiveStartDate={new Date()}
				/>
				<div className="picker-actions-div">
					<IonButton
						onClick={() => {
							setDate(new Date());
							setShowCalendar(!showCalendar);
						}}
						color="light"
						className="picker-action-buttons"
					>
						{constants.CANCEL}
					</IonButton>
					<IonButton
						color="light"
						className="picker-action-buttons"
						onClick={() => {
							setShowCalendar(!showCalendar);
							if (
								date >= new Date(props.firstAvailable) &&
								date <= new Date(props.lastAvailable) &&
								!!time_arr &&
								time_arr.length > 0
								// !!props.time_slots &&
								// props.time_slots.length > 0
							) {
								setShowSlotModal(true);
							}
						}}
					>
						{constants.OK}
					</IonButton>
				</div>
			</IonModal>
			<IonModal isOpen={showSlotModal} backdropDismiss={false} cssClass="slot-modal">
				<div>
					<div className="slot_header">
						<IonLabel className="slot_heading">Choose a time slot</IonLabel>
					</div>
					<div
						className={
							time_arr.length > 7
								? "slot_container"
								: time_arr.length > 6
								? "slot_container_6"
								: time_arr.length > 5
								? "slot_container_small"
								: time_arr.length > 3
								? "slot_container_xxsmall"
								: "slot_container_xxsmall"
						}
					>
						{/* {props.time_slots.map((ele: any, ind: number) => ( */}
						{time_arr.map((ele: any, ind: number) => (
							<div
								key={ind}
								onClick={() => changeTimeSlot(`${ele.startTime}-${ele.endTime}`)}
								className={
									slot === `${ele.startTime}-${ele.endTime}` ? "active_slot" : "slot_val"
								}
							>
								{ele.startTime}-{ele.endTime}
							</div>
						))}
					</div>
				</div>
				<div className="picker-actions-div">
					<IonButton
						onClick={() => {
							setTimeSlot("");
							setShowSlotModal(!showSlotModal);
						}}
						color="light"
						className="picker-action-buttons"
					>
						{constants.CANCEL}
					</IonButton>
					<IonButton
						color="light"
						className="picker-action-buttons"
						onClick={(slot: any) => {
							onBookingReschedule();
						}}
					>
						{constants.OK}
					</IonButton>
				</div>
			</IonModal>
			<ToastMessage
				showToast={toast.showToast}
				ToastMessage={toast.toastMessage}
				severity={toast.severity}
				onDidDismiss={() => {
					setToast({
						showToast: false,
						toastMessage: "",
						severity: "",
					});
				}}
			/>
		</>
	);
};
export default connect(
	({ cart }: any) => {
		const { firstAvailable, lastAvailable, time_slots } = cart;
		return {
			firstAvailable,
			lastAvailable,
			time_slots,
		};
	},
	{
		getTimeSlots,
		deleteBookingTransaction,
		rescheduleBooking,
		cancelBooking,
		fetchBookings,
	}
)(MyBookingsStatusCard);
